
import { defineComponent } from "vue-demi";

export default defineComponent({
  name: "NotificationsTag",

  props: {
    status: {
      type: String as () => "" | "due_soon" | "overdue" | "platform" | "home_office",
      default: "overdue",
    },
  },

  setup() {
    function formatString(str: string): string {
      if (!str) return "";

      return str.replace(/_/g, " ").replace(/\b\w/g, (char) => char.toUpperCase());
    }

    return {
      formatString,
    };
  },
});
